export const addClarifierPopoverWidth = 305
export const CLARIFIER_QUERY_SELECTOR = 'span[data-content-support="clarifier"]'
export const FROALA_EDITOR_MAX_CHAR_LIMIT = 4096
export const MAX_ALLOWED_CLARIFIER_PER_QUESTION = 10
